<!-- An entry (article) from the dictionary. -->

<template>
  <MainArticle :article="article" :settings="settings" />
</template>

<script lang='ts'>
import Vue from 'vue';
import MainArticle from '@/components/MainArticle.vue';
import { ArticleState } from '@/types/article';
import { SettingsState } from '@/store/settings';
import { PROJECT_DISPLAY_NAME } from '@/constants';
import { slugify } from "@/util/util";

export default Vue.extend({

  components: {
    MainArticle: MainArticle,
  },

  computed: {
    article(): ArticleState {
      return this.$store.state.article;
    },

    articleLemma(): string {
      return this.article.title;
    },

    settings(): SettingsState {
      return this.$store.state.settings;
    },
    shouldRedirect(): boolean {
      return (this.article.redirect.name != '' && this.article.redirect.target != '');
    }
  },

  mounted() {
    this.loadData();
  },

  beforeDestroy() {
    this.$store.commit('discardArticle');
  },

  watch: {
    $route() {
      this.loadData();
    },

    articleLemma() {
      document.title = `${this.article.title} - ${PROJECT_DISPLAY_NAME}`;
    },
    shouldRedirect(newValue) {
      if(newValue) {
        let name = this.article.redirect.name;
        let target = this.article.redirect.target;

        if (name != '' && target != '') {
          this.$router.replace({
            path: slugify(this.article.redirect['name'], this.article.redirect['target']), 
            query: { from: this.article.title, from_id: this.article.pid}
          });
        }
      }
    },
  },

  methods: {
    loadData() {
      let pid = this.$route.params.pid;
      if (!pid) {
        // Old ID, of the form "LEMMA:PID"
        const oldId = this.$route.params.title;
        [, pid] = oldId.split(':');
      }
      if (this.article.pid !== pid)
        this.$store.dispatch('loadArticle', { pid });
    },
  },

});

</script>

<style scoped lang="scss">
</style>
